import React from 'react';
import { motion } from 'framer-motion';
import CTAPair from '@/components/site/CTAPair';

export default function About() {
  return (
    <div data-testid="page-about">
      {/* Hero */}
      <section className="relative overflow-hidden bg-white text-[#031D44]">
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-20 md:pt-28 md:pb-24">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-[#FF5081]">About Sellrly</p>
          <motion.h1
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mt-5 font-display text-[44px] sm:text-5xl lg:text-6xl xl:text-[68px] font-semibold tracking-[-0.025em] leading-[1.02] max-w-5xl"
          >
            Your media, managed. Your results, <span className="text-[#FF5081]">owned.</span>
          </motion.h1>
          <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
            <p className="lg:col-span-7 text-base lg:text-lg leading-relaxed text-[#031D44]/70">
              Sellrly is the antidote to bloated agencies and expensive in-house teams. We help DTC brands,
              podcasters, creators, social sellers, and subscription businesses acquire customers efficiently by
              putting media dollars where they work hardest — across the open web, not just the duopoly of Meta and
              Google.
            </p>
            <p className="lg:col-span-5 text-base lg:text-lg leading-relaxed text-[#031D44]/70">
              We manage the entire process for you, from planning and buying to optimization and reporting. Less
              bureaucracy. More accountability. Better performance. Because your marketing budget should be generating
              customers — not funding meetings.
            </p>
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="relative bg-[#0B0F2A] text-white py-14 md:py-16">
        <div className="relative max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <h3 className="lg:col-span-8 font-display text-2xl sm:text-3xl lg:text-[34px] font-semibold tracking-[-0.02em] leading-snug">
            Growth doesn’t need more bloat or bureaucracy. It needs better execution.
          </h3>
          <div className="lg:col-span-4 flex lg:justify-end">
            <CTAPair testIdSuffix="about-strip" secondaryTarget="/case-studies" />
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative py-20 md:py-24 bg-[#000919] text-white">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] leading-[1.05]">
            Less bureaucracy. More accountability. Better performance.
          </h2>
          <p className="mt-5 text-white/60">Let’s talk.</p>
          <div className="mt-10 flex justify-center">
            <CTAPair align="center" testIdSuffix="about-final" secondaryTarget="/services" />
          </div>
        </div>
      </section>
    </div>
  );
}
